export default __webpack_public_path__ + "static/alice-c932dab24e144701223e2d32f4d8b91b.jpeg";